<div class="search-container">
  <div class="search-wrapper" [class.disabled]="disabled">
    <hyperkit-icon
      icon="search"
      size="small"
      color="inherit"
      class="left-icon"
    ></hyperkit-icon>
    <hyperkit-typography
      variant="body"
      size="md"
      color="primary"
      class="input-wrapper"
      >
      <input
        #searchInput
        type="text"
        [ngModel]="text"
        (ngModelChange)="onTextChange($event)"
        (keyup.enter)="onSearch()"
        [placeholder]="placeholder"
        [disabled]="disabled"
        class="search-input"
        />
    </hyperkit-typography>
    @if (text.length && text.length > 1) {
      <hyperkit-icon
        icon="x"
        size="small"
        color="inherit"
        class="left-icon"
        (click)="onCancel()"
      ></hyperkit-icon>
    }
    <hyperkit-button
      class="search-button"
      [disabled]="disabled"
      variant="icon"
      icon="search"
      iconPosition="left"
      color="tertiary"
      size="small"
      (click)="onSearch()"
    ></hyperkit-button>
  </div>
</div>
